import { render, staticRenderFns } from "./DownloadDataSwiper.vue?vue&type=template&id=62a1fd5d&scoped=true&"
import script from "./DownloadDataSwiper.vue?vue&type=script&lang=js&"
export * from "./DownloadDataSwiper.vue?vue&type=script&lang=js&"
import style0 from "./DownloadDataSwiper.vue?vue&type=style&index=0&id=62a1fd5d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a1fd5d",
  null
  
)

export default component.exports